<template>
  <div class="cardHeader">
    <gl-svg-icon
      :name="iconName"
      height="28"
      width="28"
      class="cardHeader__logo text text--title"
    />
    <h3 class="cardHeader__title text text--title">{{ title }}</h3>
  </div>
</template>

<script>
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'GlHeader',
  components: { GlSvgIcon },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.cardHeader {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  padding: 18px 16px;

  &__logo {
    flex-shrink: 0;
    margin-right: 12px;
  }

  &__title {
    color: #fff;
    text-transform: uppercase;
  }
}
</style>
